import Button from "../../../../common/components/Button";
import T from "../../../../common/i18n/Text";
import React from "react";
import "./Hero.css";

export const Hero = () => {
    return heroItem();
};

const heroItem = () => {
    return <div className="hero">
        <div className="background"/>
        <div className="content">
            <h1><T path="home.hero.presentation" /></h1>
            <p><T path="home.hero.description-hero" /></p>
            <a className="hero-cta" href="/games/interview">
                <Button type="cta" name="hero-play"><T path="home.hero.play" /></Button>
            </a>
        </div>
    </div>
};
